const GENDER = {
  1: 'male',
  2: 'female',
};

export { GENDER };
